import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import PlayStoreIcon from './PlayStoreIcon';
import appLogo from '../assets/logo.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, id) => {
    setMobileMenu(false);
    if (location.pathname !== '/') {
      e.preventDefault();
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <header
      className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0B0F19]/90 backdrop-blur-md border-b border-gray-800/80 shadow-2xl shadow-black/40' : 'bg-transparent'
        }`}
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link 
          to="/"
          onClick={() => {
            setMobileMenu(false);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="flex items-center gap-3 group tracking-tight font-extrabold text-xl text-white focus:outline-none"
        >
          <img src={appLogo} alt="PFP AI Logo" className="w-10 h-10 object-contain group-hover:scale-105 transition-transform duration-300" />
          <span>PFP <span className="text-[#E63946]">AI</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 font-medium text-sm text-gray-300">
          <a href="#features" onClick={(e) => handleNavClick(e, 'features')} className="hover:text-white transition-colors">Features</a>
          <a href="#reviews" onClick={(e) => handleNavClick(e, 'reviews')} className="hover:text-white transition-colors">Reviews</a>
          <a href="#faq" onClick={(e) => handleNavClick(e, 'faq')} className="hover:text-white transition-colors">FAQ</a>
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a 
            href="https://play.google.com/store/apps/details?id=com.pfpaiapp&pcampaignid=web_share" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-block focus:outline-none"
          >
            <PlayStoreIcon className="h-40 md:h-40 w-auto" />
          </a>
        </div>

        <button
          onClick={() => setMobileMenu(!mobileMenu)}
          className="md:hidden text-gray-400 hover:text-white focus:outline-none"
        >
          {mobileMenu ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {mobileMenu && (
        <div className="md:hidden bg-[#0e1320] border-b border-gray-800 px-6 py-6 flex flex-col gap-4 animate-fade-in">
          <a href="#features" onClick={(e) => handleNavClick(e, 'features')} className="text-gray-300 font-medium hover:text-white">Features</a>
          <a href="#reviews" onClick={(e) => handleNavClick(e, 'reviews')} className="text-gray-300 font-medium hover:text-white">Reviews</a>
          <a href="#faq" onClick={(e) => handleNavClick(e, 'faq')} className="text-gray-300 font-medium hover:text-white">FAQ</a>
          <a 
            href="https://play.google.com/store/apps/details?id=com.pfpaiapp&pcampaignid=web_share" 
            target="_blank" 
            rel="noopener noreferrer" 
            onClick={() => setMobileMenu(false)} 
            className="inline-block mt-2 w-fit"
          >
            <PlayStoreIcon className="h-10 w-auto" />
          </a>
        </div>
      )}
    </header>
  );
}
